import appSettings from "../appSettings.json";

const getApiBaseUrl = () => {
    return appSettings.apiBaseUrl[process.env.NODE_ENV];
}

export const revenueEndpoint = getApiBaseUrl() + "/revenue";
export const jobsEndpoint = getApiBaseUrl() + "/jobs";
export const engineersEndpoint = getApiBaseUrl() + "/engineers";
export const usersEndpoint = getApiBaseUrl() + "/users";
export const authenticationEndpoint = getApiBaseUrl() + "/authentication";

export const engineersJobsRoute = "/engineer";
export const manageJobsRoute = "/manage/jobs";
export const manageEngineersRoute = "/manage/engineers";
export const changePasswordRoute = "/account/changepassword";
export const logoutRoute = "/logout";
export const loginRoute = "/login";
